import { useTranslations } from 'next-intl'

export const GravelPriceTable = () => {
  const t = useTranslations()
  const transportPrices = t.raw('gravelPage.transport.items') as string[]

  return (
    <div className="mt-4 space-y-4 rounded-xl border border-black bg-white px-4 py-2">
      <details>
        <summary className="cursor-pointer select-none">
          <h2 className="inline text-xl font-semibold">{t('gravelPage.pricing.title')}</h2>
        </summary>
        <p className="my-2">{t('gravelPage.pricing.subtitle')}</p>
        <table className="mt-6 w-full text-sm sm:text-base [&_td]:border [&_td]:leading-7">
          <thead>
            <tr>
              <td colSpan={3} className="bg-blue-200 text-xl font-semibold">
                {t('gravelPage.pricing.products.pukkAndSubbus')}
              </td>
            </tr>
            <tr>
              <td>
                <span className="sm:hidden">{t('gravelPage.pricing.tableHeaders.quantityShort')}</span>
                <span className="hidden sm:block">{t('gravelPage.pricing.tableHeaders.quantity')}</span>
              </td>
              <td>{t('gravelPage.pricing.tableHeaders.priceExVat')}</td>
              <td>{t('gravelPage.pricing.tableHeaders.priceIncVat')}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>2 130</td>
              <td>2 663</td>
            </tr>
            <tr>
              <td>2</td>
              <td>3 180</td>
              <td>3 975</td>
            </tr>
            <tr>
              <td>3</td>
              <td>4 180</td>
              <td>5 225</td>
            </tr>
            <tr>
              <td>4</td>
              <td>5 320</td>
              <td>6 538</td>
            </tr>
            <tr>
              <td>5</td>
              <td>6 230</td>
              <td>7 788</td>
            </tr>
            <tr>
              <td>6</td>
              <td>7 130</td>
              <td>8 913</td>
            </tr>
            <tr>
              <td>7</td>
              <td>8 130</td>
              <td>10 163</td>
            </tr>
            <tr>
              <td>8</td>
              <td>9 130</td>
              <td>11 413</td>
            </tr>
            <tr>
              <td>9</td>
              <td>10 180</td>
              <td>12 725</td>
            </tr>
            <tr>
              <td>10</td>
              <td>11 180</td>
              <td>13 975</td>
            </tr>
          </tbody>
        </table>
        <table className="mt-6 w-full text-sm sm:text-base [&_td]:border [&_td]:leading-7">
          <thead>
            <tr>
              <td colSpan={3} className="bg-blue-200 text-xl font-semibold">
                {t('gravelPage.pricing.products.plantejord')}
              </td>
            </tr>
            <tr>
              <td>
                <span className="sm:hidden">{t('gravelPage.pricing.tableHeaders.quantityShort')}</span>
                <span className="hidden sm:block">{t('gravelPage.pricing.tableHeaders.quantity')}</span>
              </td>
              <td>{t('gravelPage.pricing.tableHeaders.priceExVat')}</td>
              <td>{t('gravelPage.pricing.tableHeaders.priceIncVat')}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>2 980</td>
              <td>3 725</td>
            </tr>
            <tr>
              <td>2</td>
              <td>4 830</td>
              <td>6 038</td>
            </tr>
            <tr>
              <td>3</td>
              <td>6 580</td>
              <td>8 225</td>
            </tr>
            <tr>
              <td>4</td>
              <td>8 430</td>
              <td>10 538</td>
            </tr>
            <tr>
              <td>5</td>
              <td>10 280</td>
              <td>12 850</td>
            </tr>
            <tr>
              <td>6</td>
              <td>11 830</td>
              <td>14 788</td>
            </tr>
            <tr>
              <td>7</td>
              <td>13 630</td>
              <td>17 038</td>
            </tr>
            <tr>
              <td>8</td>
              <td>15 430</td>
              <td>19 288</td>
            </tr>
            <tr>
              <td>9</td>
              <td>17 230</td>
              <td>21 538</td>
            </tr>
            <tr>
              <td>10</td>
              <td>19 030</td>
              <td>23 788</td>
            </tr>
          </tbody>
        </table>
        <div>
          <h2 className="mt-8 text-xl font-bold">Transport</h2>
          <ul className="list-disc pl-5">
            {transportPrices.map((item, i) => (
              <li key={i} className="mt-2">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </details>
    </div>
  )
}
